import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('No verification token provided');
      return;
    }

    fetch(`/api/verify/email?token=${token}`)
      .then(res => res.text())
      .then(text => {
        if (text.includes('verified')) {
          setStatus('success');
          setMessage('Email verified! You can now log in.');
        } else {
          setStatus('error');
          setMessage(text);
        }
      })
      .catch(err => {
        setStatus('error');
        setMessage('Verification failed. Please try again.');
      });
  }, [token]);

  return (
    <div className="max-w-md mx-auto text-center py-12">
      <div className="bg-white rounded-lg shadow-md p-8">
        {status === 'verifying' && <div>Verifying your email...</div>}
        {status === 'success' && (
          <>
            <div className="text-6xl mb-4">✅</div>
            <h1 className="text-2xl font-bold mb-2">Email Verified!</h1>
            <p className="mb-4">{message}</p>
            <Link to="/login" className="bg-green-600 text-white px-4 py-2 rounded">Log In</Link>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="text-6xl mb-4">❌</div>
            <h1 className="text-2xl font-bold mb-2">Verification Failed</h1>
            <p className="mb-4 text-red-600">{message}</p>
            <Link to="/login" className="bg-gray-300 text-gray-700 px-4 py-2 rounded">Back to Login</Link>
          </>
        )}
      </div>
    </div>
  );
}
